import { useContext } from 'react';
import AuthContext from 'src/contexts/authentication/AuthProvider';
import { PermissionLevel } from '../types/claims/profilePermission';

export interface Area {
  tag: string;
  nombre: string;
  nivelPermiso: PermissionLevel | undefined;
}

export interface AreaFilter {
  tag: string;
  nombre: string;
  filtroActivo: boolean;
}

export const useDocumentPermissions = () => {
  const { user } = useContext(AuthContext);
  const allAreas: Area[] = [
    {
      tag: 'Mantencion',
      nombre: 'Mantención',
      nivelPermiso: user?.claims?.['DocumentosMantencion'],
    },
    {
      tag: 'Planificacion',
      nombre: 'Planificación',
      nivelPermiso: user?.claims?.['DocumentosPlanificacion'],
    },
    {
      tag: 'RRHH',
      nombre: 'RRHH',
      nivelPermiso: user?.claims?.['DocumentosRRHH'],
    },
    {
      tag: 'Operaciones',
      nombre: 'Operaciones',
      nivelPermiso: user?.claims?.['DocumentosOperaciones'],
    },
    {
      tag: 'Finanzas',
      nombre: 'Finanzas',
      nivelPermiso: user?.claims?.['DocumentosFinanzas'],
    },
    {
      tag: 'Logistica',
      nombre: 'Logística',
      nivelPermiso: user?.claims?.['DocumentosLogistica'],
    },
    {
      tag: 'Electromovilidad',
      nombre: 'Electromovilidad',
      nivelPermiso: user?.claims?.['DocumentosElectromovilidad'],
    },
    {
      tag: 'Combustible',
      nombre: 'Combustible',
      nivelPermiso: user?.claims?.['DocumentosCombustible'],
    },
    {
      tag: 'Prevencion',
      nombre: 'Prevención y Seguridad',
      nivelPermiso: user?.claims?.['DocumentosPrevencionySeguridad'],
    },
  ];
  const areas = allAreas.filter(
    (area) =>
      area.nivelPermiso !== undefined &&
      area.nivelPermiso !== PermissionLevel.None
  );
  const areaFilters: AreaFilter[] = allAreas.map((ae) => ({
    tag: ae.tag,
    nombre: ae.nombre,
    filtroActivo: false,
  }));
  return { areas, areaFilters };
};

export const useAllDocumentPermissions = () => {
  // Definir todas las áreas como un array de strings
  const allAreas: string[] = [
    'Mantencion',
    'Planificacion',
    'RRHH',
    'Operaciones',
    'Finanzas',
    'Logistica',
    'Electromovilidad',
    'Combustible',
    'Prevencion',
  ];

  return allAreas;
};
